import { render, staticRenderFns } from "./CoozzyWarningIcon.vue?vue&type=template&id=3d1155aa&scoped=true"
import script from "./CoozzyWarningIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyWarningIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1155aa",
  null
  
)

export default component.exports